import 'braid-design-system/reset';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import type { ConfigContextTypes } from 'src/types';

import { App } from './App/App';
import { StaticRenderProvider } from './utils/hooks/useStaticRender';

export default (config: ConfigContextTypes) => {
  const { language, locale } = config;

  const basename = !language.includes('en')
    ? `${locale.toLowerCase()}/partners`
    : 'partners';

  createRoot(document.getElementById('app')!).render(
    <BrowserRouter basename={basename}>
      <StaticRenderProvider value={false}>
        <App config={config} />
      </StaticRenderProvider>
    </BrowserRouter>,
  );
};
